<div class="chatBox discussionSubtitleBg">
  <div *ngIf="!editClicked" [ngClass]="{'pb-2' : !isSelf}">
    {{mainPost?.text}}
  </div>
  <div *ngIf="editClicked">
    <label class="form-label d-flex justify-content-end" for="Edit"></label>
    <textarea [(ngModel)]="reply" rows="4" type="text" id="Edit" name="EditField"
              class="form-control chatBox"
              sbAutofocus></textarea>
  </div>
  <ng-container *ngIf="isSelf">
    <hr>
    <div> <!-- header -->
      <div class="d-flex py-1">
        <div class="ml-auto">
          <sb-icon (click)="setDoneTopic($event)" class="cursor-pointer mr-2" icon="success"></sb-icon>
          <sb-icon (click)="editTopic($event)" class="cursor-pointer mx-2" icon="edit"></sb-icon>
          <sb-icon (click)="deleteTopic($event)" class="cursor-pointer mr-2" icon="trash"></sb-icon>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- body -->
  <!-- <div *ngFor="" class="col-md-2"> chatschildren for -->

</div>
